import React from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Input,
} from "antd";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";

import { DownOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import KeyNotTaggedReportStore from "../store/KeyNotTaggedReportStore";

const { RangePicker } = DatePicker;
const { Option } = Select;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 270;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 90;
    }
  });

  return array;
};

class KeyNotTaggedReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.KeyNotTaggedReportStore = new KeyNotTaggedReportStore();
    this.vehicleStore = new VehicleStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectAllVehicles: false,
      companyId: "",
      modalVisible: false,
      column: "",
      filter: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      distance: 0,
      showMonthPopup: false,
      Notcompany: false,
      Notasset: false,

      selectedColumns: widthAdderFunc([
        {
          // title: "Vehicle No",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          width: "15%",
          key: "vehicleNo",
        },
        {
          // title: "Driver Name",
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
          ),
          dataIndex: "name",
          width: "15%",
          key: "name",
        },
        {
          // title: "Start Date/Time",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_STARTDATETIME_"
          ),
          dataIndex: "startTime",
          width: "15%",
          key: "startTime",
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: "Start Address",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_STARTADDRESS_"
          ),
          dataIndex: "startLocation",
          width: "15%",
          key: "startLocation",
        },
        {
          // title: "Stop Date/Time",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_STOPDATETIME_"
          ),
          dataIndex: "stopTime",
          width: "15%",
          key: "stopTime",
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: "Stop Address",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_STOPADDRESS_"
          ),
          dataIndex: "stopLocation",
          width: "15%",
          key: "stopLocation",
        },
        {
          // title: "Distance Travelled",
          title: context.translate("_FLEET_RULESELECTORDETAIL_RULE13_TITLE_"),
          dataIndex: "distanceTravelled",
          width: "15%",
          key: "distanceTravelled",
        },
        {
          // title: "Duration",
          title: context.translate(
            "_FLEET_REPORTS_STARTSTOPREPORT_ELAPSEDTIME_"
          ),
          dataIndex: "elapsedTime",
          width: "15%",
          key: "elapsedTime",
        },
        {
          // title: "Start Odometer",
          title: context.translate("_FLEET_REPORTS_DISTANCEREPORT_STARTOD_"),
          dataIndex: "startDist",
          width: "15%",
          key: "startDist",
        },
        {
          // title: "End Odometer",
          title: context.translate("_END_ODOMETER_"),
          dataIndex: "stopDist",
          width: "15%",
          key: "stopDist",
        },
        // {
        //   // title: "Tag Id",
        //   title: context.translate("_TAG_ID_"),
        //   dataIndex: "tagId",
        //   width: "15%",
        //   key: "tagId",
        // },
        // {
        //   // title: "Tag Id",
        //   title: context.translate("_IBUTTON_ID_"),
        //   dataIndex: "ibuttonid",
        //   width: "15%",
        //   key: "ibuttonid",
        // },
        {
          // title: "Fuel Consumed",
          title: context.translate("_FUEL_CONSUMED_"),
          dataIndex: "fuelConsumed",
          width: "15%",
          key: "fuelconsumed",
        },
      ]),
    };
    this.menuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXCEL_"),
          key: "excel",
        },
        {
          // label: "PDF",
          label: context.translate("_PDF_"),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            intervel: this.state.intervel,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            userId: 1,
            filter: this.state.filter,
            distance: this.state.distance,
            colList: result.toString(),
          };
          if (val.key == "excel") {
            this.KeyNotTaggedReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.KeyNotTaggedReportStore.exportpdf(getData);
          }
        }
      },
    };

    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      {
        // title: "Start Load Voltage",
        title: context.translate("_START_LOAD_VOLTAGE_"),
        dataIndex: "startloadvoltage",
        width: 15,
        key: "startLoadVoltage",
        render: (value) => {
          if (!value || value == "") {
            return "NA";
          }
          return value;
        },
      },
      {
        // title: "End Load Voltage",
        title: context.translate("_END_LOAD_VOLTAGE_"),
        dataIndex: "endloadvoltage",
        width: 15,
        key: "endLoadVoltage",
        render: (value) => {
          if (!value || value == "") {
            return "NA";
          }
          return value;
        },
      },
      {
        // title: "Start Luggage Load",
        title: context.translate("_START_LUGGAGE_LOAD_"),
        dataIndex: "weightFactor",
        width: 15,
        key: "startLuggageeLoad",
        render: (value, r) => {
          var loadVoltage = r.startloadvoltage;
          var weightFactor = r.weightFactor;
          var emptyWeight = r.emptyWeight;

          if (
            loadVoltage != null &&
            weightFactor != null &&
            emptyWeight != null
          ) {
            if (loadVoltage >= r.minVolt && loadVoltage <= r.maxVolt) {
              return 0;
            }
            var totalWeightKg = loadVoltage * weightFactor;
            if (totalWeightKg < emptyWeight) {
              totalWeightKg = emptyWeight;
            }

            var loadWeight = totalWeightKg - emptyWeight;
            return Math.round(loadWeight);
          } else {
            if (r.vehicleNo == "Total") {
              return 0;
            } else {
              return "NA";
            }
          }
        },
      },
      {
        // title: "End Luggage Load",
        title: context.translate("_END_LUGGAGE_LOAD_"),
        dataIndex: "weightFactor",
        width: 15,
        key: "endLuggageLoad",
        render: (value, r) => {
          var loadVoltage = r.startloadvoltage;
          var weightFactor = r.weightFactor;
          var emptyWeight = r.emptyWeight;
          if (
            loadVoltage != null &&
            weightFactor != null &&
            emptyWeight != null
          ) {
            if (loadVoltage >= r.minVolt && loadVoltage <= r.maxVolt) {
              return 0;
            }
            var totalWeightKg = loadVoltage * weightFactor;
            if (totalWeightKg < emptyWeight) {
              totalWeightKg = emptyWeight;
            }

            var loadWeight = totalWeightKg - emptyWeight;
            return Math.round(loadWeight);
          } else {
            if (r.vehicleNo == "Total") {
              return 0;
            } else {
              return "NA";
            }
          }
        },
      },
      {
        // title: "Start Empty Weight",
        title: context.translate("_START_EMPTY_WEIGHT_"),
        dataIndex: "emptyWeight",
        width: 15,
        key: "startEmptyWeight",
        render: (value) => {
          if (value) {
            return Math.round(value);
          } else {
            return "NA";
          }
        },
      },
      {
        // title: "End Empty Weight",
        title: context.translate("_END_EMPTY_WEIGHT_"),
        dataIndex: "emptyWeight",
        width: 15,
        key: "endEmptyWeight",
        render: (value) => {
          if (value) {
            return Math.round(value);
          } else {
            return "NA";
          }
        },
      },
      {
        // title: "Start Total Weight",
        title: context.translate("_START_TOTAL_WEIGHT_"),
        dataIndex: "weightFactor",
        width: 15,
        key: "starttotalWeight",
        render: (value, r) => {
          var loadVoltage = r.startloadvoltage;

          var weightFactor = r.weightFactor;

          if (loadVoltage != null && weightFactor != null) {
            var loadKg = loadVoltage * weightFactor;

            if (loadKg > r.emptyWeight) {
              return Math.round(loadKg);
            } else {
              return Math.round(r.emptyWeight);
            }
          } else {
            if (r.vehicleNo == "Total") {
              return 0;
            } else {
              return "NA";
            }
          }
        },
      },
      {
        // title: "End Total Weight",
        title: context.translate("_END_TOTAL_WEIGHT_"),
        dataIndex: "weightFactor",
        width: 15,
        key: "endtotalWeight",
        render: function (value, r) {
          var loadVoltage = r.endloadvoltage;
          var weightFactor = r.weightFactor;

          if (loadVoltage != null && weightFactor != null) {
            var loadKg = loadVoltage * weightFactor;

            if (loadKg > r.emptyWeight) {
              return Math.round(loadKg);
            } else {
              return Math.round(r.emptyWeight);
            }
          } else {
            if (r.vehicleNo == "Total") {
              return 0;
            } else {
              return "NA";
            }
          }
        },
      },
    ]);
  }
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false, currentPage: 1 });
    this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    // await this.handleSearch();
    await this.setState({ loadData: 1 });
  }

  async handleSearch() {
    this.setState({ Notasset: false });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.KeyNotTaggedReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          geoZoneId: this.state.sele,
          distance: this.state.distance,
        });
        this.setState({ loadData: 1 });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss,";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({
        fromDate: "",
        toDate: "",
      });
    }
  };

  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;

    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              {" "}
              <div className="heading">
                {this.context.translate("_KEY_NOT_TAGGED_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.KeyNotTaggedReportStore?.keyNotTagged?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
          className="blackbg"
        >
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });

                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}

                <Select
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <RangePicker
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />
                <Input
                  style={{ width: 100 }}
                  placeholder={this.context.translate("_DISTANCE_")}
                  value={this.state.distance}
                  onChange={(e) => this.setState({ distance: e.target.value })}
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ currentPage: 1, pageSize: 50 });
                    await this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.KeyNotTaggedReportStore?.total}
            columns={this.state.column}
            dataSource={this.KeyNotTaggedReportStore?.keyNotTagged}
            loading={this.KeyNotTaggedReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
        <Modal
          open={this.state.modalVisible}
          width={300}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
      </>
    );
  }
}
KeyNotTaggedReport.contextType = StoreContext;
export default observer(withRouter(KeyNotTaggedReport));
